import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { JsonService } from 'src/app/services/json.service';
import { TranslateService } from 'src/app/services/translate.service';

@Component({
  selector: 'app-pincode',
  templateUrl: './pincode.component.html',
  styleUrls: ['./pincode.component.scss'],
})
export class PincodeComponent implements OnInit {
  @Input() variable;
  @Output() variableChange = new EventEmitter();
  pincodeObject: any = {};
  filteredPinCode = [];
  showPincodeOption1: boolean = false;

  constructor(public trans: TranslateService, private jsonService: JsonService) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    
    if (this.variable) {
      this.pincodeObject.pincode = this.variable.pincode;
      this.pincodeObject.state = this.variable.state;
      this.pincodeObject.district = this.variable.district;
      this.pincodeObject.town = this.variable.town;
      this.pincodeObject.area = this.variable.area;
      this.pincodeObject.current_address2 = this.variable.current_address2;
      
    }
    console.log("this.pincodeObject", this.pincodeObject);
  }


  searchPincode(search) {
    if (search.length > 3) {
      this.showPincodeOption1 = true;
      this.filteredPinCode = this.jsonService.areaList.area.filter(x => x.toLowerCase().indexOf(search.toLowerCase()) > -1);
    } else {
      this.showPincodeOption1 = false;
    }
  }
  setAddress(pin: string, type: string) {
    this.pincodeObject.pincode = pin.split(':')[0];
    this.pincodeObject.area = pin.split(':')[1].split(",")[0];
    this.pincodeObject.town = pin.split(':')[1].split(",")[1];

    for (let key in this.jsonService.districtList) {

      const districtEntry = this.jsonService.districtList[key]; // e.g., "CHATTISGARH, 492, 493"

      if (districtEntry) {
        const parts = districtEntry.split(", "); // ["CHATTISGARH", "492", "493"]
        const state = parts[0];
        const codes = parts.slice(1); // ["492", "493"]
        const pincodePrefix = this.pincodeObject.pincode?.substring(0, 3);

        if (pincodePrefix && codes.includes(pincodePrefix)) {
          console.log(districtEntry, key);
          this.pincodeObject.state = state;
          this.pincodeObject.district = key;
          break; // Exit after first match (optional, remove if multiple matches are possible)
        }
      }
      if (key == 'Puruliya') {
        break;
      }
    }
    if (this.pincodeObject.town) {
      this.pincodeObject[type + 2] = this.pincodeObject.area + ", " + this.pincodeObject.town + ", " + this.pincodeObject.district + ", " + this.pincodeObject.state + ", India, " + this.pincodeObject.pincode;
    } else {
      this.pincodeObject[type + 2] = this.pincodeObject.area + ", " + this.pincodeObject.district + ", " + this.pincodeObject.state + ", India, " + this.pincodeObject.pincode;
      this.pincodeObject.town = this.pincodeObject.district;
    }

    this.pincodeObject.country = "India";
    console.log(this.pincodeObject[type + 2]);
    this.showPincodeOption1 = false;
    if (this.variable) {
      this.variable.pincode = this.pincodeObject.pincode;
      this.variable.state = this.pincodeObject.state;
      this.variable.district = this.pincodeObject.district;
      this.variable.town = this.pincodeObject.town;
      this.variable.area = this.pincodeObject.area;
      this.variable.country = this.pincodeObject.country;
      this.variable.current_address2 = this.pincodeObject.current_address2;

    }
    this.variableChange.emit(this.variable);
  }
}
